    var modal = document.getElementById("afterpayModal");
        // var openModalBtn = document.querySelector(".open-modal-btn");
        var closeModalBtn = document.querySelector(".close-modal-btn");

       var openModalBtns = document.querySelectorAll(".open-modal-btn");

          openModalBtns.forEach(function(btn) {
            btn.addEventListener("click", function(e) {
              e.preventDefault(); 
              modal.style.display = "block"; 
              // alert('opened');
            });
          });

       
        function closeModal() {
          modal.style.display = "none"; 
        }

        
        window.onclick = function(event) {
          if (event.target === modal) {
            modal.style.display = "none";
          }
        }



